import { render, staticRenderFns } from "./viewOrder.vue?vue&type=template&id=a23ed788&scoped=true"
import script from "./viewOrder.vue?vue&type=script&lang=js"
export * from "./viewOrder.vue?vue&type=script&lang=js"
import style0 from "./viewOrder.vue?vue&type=style&index=0&id=a23ed788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ed788",
  null
  
)

export default component.exports